import { Loading } from "app/utils/loadingR/Loading";
import { excelFileToJSON } from "global.d";
import { FC, useEffect, useState } from "react";
import { fixedRecipe, fixedStructure, getContact, getDataDays, ingredientFrequency, insertStructure, ponderationWeighting, structureWeighting, weekDays } from "./bulkLoad.service";

const BulkLoad: FC<BulkLoadProps> = (props) => {
    const [load, setLoad] = useState(false)
    const [file, setFile] = useState<any>();
    const matriz = ["Datos_contrato", "Dias_semanas",
        "Estructura_Insert", "Estructura_Fija", "Frecuencia_Ingredientes",
        "Ponderacion_Ingrediente", "Ponderaciones_Estructura", "Receta_Fija"]
    const saveFile = () => {
        const dataFile: any = document.getElementById("formFile")
        if (dataFile.files) {
            excelFileToJSON(dataFile.files[0], setFile)
        }

    }
    useEffect(() => {
        ; (async () => {
            if (file) {
                setLoad(true)
                const result = await getDataDays(file);
                const querys: any = await Promise.all(matriz.map(async (item: string) => {
                    const dataItem: any = file[item];
                    if (item === "Datos_contrato" && file[item]) {
                        if (dataItem) {
                            return getContact(dataItem)
                        }
                    } else if (item === "Dias_semanas") {
                        if (dataItem) {
                            return weekDays(dataItem, result)
                        }
                    } else if (item === "Estructura_Insert") {
                        if (dataItem) {
                            return await insertStructure(file, item, dataItem)
                        }
                    } else if (item === "Estructura_Fija") {
                        if (dataItem) {
                            return await fixedStructure(file, item, dataItem)
                        }
                    }
                    else if (item === "Receta_Fija") {
                        if (dataItem) {
                            return await fixedRecipe(file, item, dataItem)
                        }
                    }
                    else if (item === "Frecuencia_Ingredientes") {
                        if (dataItem) {
                            return await ingredientFrequency(file, item, dataItem)
                        }
                    }else if (item === "Ponderaciones_Estructura"){
                        if (dataItem) {
                            return await structureWeighting(dataItem)
                        }
                    }else if (item === "Ponderacion_Ingrediente"){
                        if (dataItem) {
                            return await ponderationWeighting(dataItem)
                        }
                    }
                }))
                setLoad(false)
            }
        })();
    }, [file])
    return <>
        <Loading open={load} />
        <h1>Carga Masiva</h1>
        <div className="mb-3">
            <label className="form-label" >Buscar Archivo Base</label>
            <input className="form-control" type="file" id="formFile" />
        </div>
        <button onClick={saveFile}>Cargar Archivo</button>
    </>
}
interface BulkLoadProps {

}
export { BulkLoad }